import { render, staticRenderFns } from "./iconFrom.vue?vue&type=template&id=8edc5cf4&scoped=true"
import script from "./iconFrom.vue?vue&type=script&lang=js"
export * from "./iconFrom.vue?vue&type=script&lang=js"
import style0 from "./iconFrom.vue?vue&type=style&index=0&id=8edc5cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edc5cf4",
  null
  
)

export default component.exports